import _ from 'lodash';
import { API_GET_LIST_PROFESSIONAL_SOLUTION_MY_SOLUTION, API_GET_LIST_PROFESSIONAL_SOLUTION_MY_SOLUTION_SUCCESS, API_UPDATE_PROFESSIONAL_SOLUTION_ACCEPTANCE_SUCCESS, API_UPDATE_PROFESSIONAL_SOLUTION_DESTINATION_SUCCESS, API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_CONSIDERATION_SUCCESS, API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_MEMO_SUCCESS, API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_ORDER_SUCCESS, API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_REPLAY_SUCCESS, API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_REVIEW_SUCCESS, API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_SEND_OFF_SUCCESS, API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_STAFF_SUCCESS, API_UPDATE_PROFESSIONAL_SOLUTION_REPRESENTATIVE_COMMIT_SUCCESS, API_UPDATE_PROFESSIONAL_SOLUTION_REPRESENTATIVE_SUCCESS, SHOW_ALL_ORDERS_OF_PROFESSIONAL_MY_SOLUTION, TOGGLE_ORDERS_OF_PROFESSIONAL_MY_SOLUTION, } from '../actions/ProfessionalMySolutionActions';
import { API_CREATE_PROFESSIONAL_SOLUTION_SUCCESS, API_DELETE_PROFESSIONAL_SOLUTION_SUCCESS, API_UPDATE_PROFESSIONAL_SOLUTION_SUCCESS, } from '../actions/ProfessionalSolutionActions';
const setAllList = (newState) => (Object.assign(Object.assign({}, newState), { allList: _.flatten(Object.values(newState.list)) }));
const getExpansions = (orderExpansions, id) => orderExpansions[id] || { mode: 'view', show: false };
const updateExpansions = (orderExpansions, id, mode) => {
    const expansion = getExpansions(orderExpansions, id);
    return Object.assign(Object.assign({}, orderExpansions), { [id]: Object.assign(Object.assign({}, expansion), mode) });
};
const toggleShow = (orderExpansions, id) => {
    const { show } = getExpansions(orderExpansions, id);
    return updateExpansions(orderExpansions, id, { show: !show });
};
const updateSolution = (state, solution) => {
    const { list } = state;
    const listKeys = Object.keys(list);
    const newList = _.fromPairs(listKeys.map((key) => {
        const solutions = list[key];
        return [
            key,
            solutions.map((solutionDataObj) => {
                const s = solutionDataObj.solution;
                if (s.id === solution.id) {
                    return Object.assign(Object.assign({}, solutionDataObj), { solution });
                }
                return solutionDataObj;
            }),
        ];
    }));
    return Object.assign(Object.assign({}, state), { allList: _.flatten(Object.values(newList)), list: newList });
};
const deleteSolution = (state, solution) => {
    const listKeys = Object.keys(state.list);
    const newList = _.fromPairs(listKeys.map((key) => {
        const solutions = state.list[key];
        return [key, solutions.filter((s) => s.solution.id !== solution.id)];
    }));
    return setAllList(Object.assign(Object.assign({}, state), { allList: _.flatten(Object.values(newList)), list: newList }));
};
const findOrderFromNestList = (list, orderId) => {
    const listKeys = Object.keys(list);
    for (let i = 0; i <= listKeys.length; i += 1) {
        const solutions = list[listKeys[i]];
        for (let j = 0; j <= solutions.length; j += 1) {
            const solution = solutions[j];
            const { orders } = solution;
            const orderIndex = orders.findIndex((o) => o.id === orderId);
            if (orderIndex >= 0) {
                return {
                    listKey: listKeys[i],
                    orderKey: orderIndex,
                    solutionKey: j,
                };
            }
        }
    }
    return null;
};
const updateOrder = (state, order) => {
    const { list } = state;
    const { id } = order;
    let newList = list;
    const result = findOrderFromNestList(list, id);
    if (result) {
        const { listKey, orderKey, solutionKey } = result;
        const updateSolutions = newList[listKey];
        const updateOrders = updateSolutions[solutionKey].orders;
        updateOrders[orderKey] = order;
        updateSolutions[solutionKey] = Object.assign(Object.assign({}, updateSolutions[solutionKey]), { orders: [...updateOrders] });
        newList = Object.assign(Object.assign({}, newList), { [listKey]: [...updateSolutions] });
    }
    return setAllList(Object.assign(Object.assign({}, state), { allList: Object.values(newList), list: Object.assign({}, newList) }));
};
const INITIAL_STATE = {
    allList: [],
    list: {},
    orderExpansions: {},
    solutionTotal: 0,
};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { meta, payload, total, type }) => {
    switch (type) {
        case API_CREATE_PROFESSIONAL_SOLUTION_SUCCESS:
        case API_UPDATE_PROFESSIONAL_SOLUTION_SUCCESS: {
            return Object.assign({}, INITIAL_STATE);
        }
        case TOGGLE_ORDERS_OF_PROFESSIONAL_MY_SOLUTION: {
            // 対応状況の展開
            const { orderExpansions } = state;
            const { solutionId } = payload;
            const expansions = toggleShow(orderExpansions, solutionId);
            return Object.assign(Object.assign({}, state), { orderExpansions: Object.assign({}, expansions) });
        }
        case SHOW_ALL_ORDERS_OF_PROFESSIONAL_MY_SOLUTION: {
            // もっと見るの更新
            const { orderExpansions } = state;
            const { solutionId } = payload;
            const mode = { mode: 'all' };
            const expansions = updateExpansions(orderExpansions, solutionId, mode);
            return Object.assign(Object.assign({}, state), { orderExpansions: Object.assign({}, expansions) });
        }
        case API_GET_LIST_PROFESSIONAL_SOLUTION_MY_SOLUTION: {
            // データの取得が走るので、既存のデータは捨てる
            return Object.assign({}, INITIAL_STATE);
        }
        case API_GET_LIST_PROFESSIONAL_SOLUTION_MY_SOLUTION_SUCCESS: {
            // 取得データの反映
            const setList = Object.assign(Object.assign({}, state.list), { [meta.page]: payload.list });
            return setAllList(Object.assign(Object.assign({}, state), { list: setList, solutionTotal: total }));
        }
        case API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_CONSIDERATION_SUCCESS: {
            // 再検討した場合
            return updateOrder(state, payload);
        }
        case API_UPDATE_PROFESSIONAL_SOLUTION_REPRESENTATIVE_COMMIT_SUCCESS: {
            // 責任者の招待を承認・否認した場合
            if (meta.apiInput) {
                return updateSolution(state, payload);
            }
            return deleteSolution(state, payload);
        }
        case API_UPDATE_PROFESSIONAL_SOLUTION_REPRESENTATIVE_SUCCESS: {
            // 責任者の招待（特に何も変わらない）
            return state;
        }
        case API_UPDATE_PROFESSIONAL_SOLUTION_ACCEPTANCE_SUCCESS: {
            // 開始可能時期の変更（特に何も変わらない => 画面再描画は不要）
            return state;
        }
        case API_UPDATE_PROFESSIONAL_SOLUTION_DESTINATION_SUCCESS: {
            // 請求先の変更
            return updateSolution(state, payload);
        }
        case API_DELETE_PROFESSIONAL_SOLUTION_SUCCESS: {
            // 削除の反映
            const id = parseInt(meta.apiPath.match(/\/professional\/solution\/(\d+)/)[1], 10);
            return deleteSolution(state, { id });
        }
        case API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_REPLAY_SUCCESS: {
            // 初回返信の変更
            return updateOrder(state, payload);
        }
        case API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_STAFF_SUCCESS: {
            // 担当者の変更
            return updateOrder(state, payload);
        }
        case API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_MEMO_SUCCESS: {
            // メモの更新（特に何も変わらない => 画面再描画は不要）
            return state;
        }
        case API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_ORDER_SUCCESS: {
            // 受注の更新
            return updateOrder(state, payload);
        }
        case API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_SEND_OFF_SUCCESS: {
            // 見送りの更新
            return updateOrder(state, payload);
        }
        case API_UPDATE_PROFESSIONAL_SOLUTION_ORDER_REVIEW_SUCCESS: {
            // レビューの更新
            return updateOrder(state, payload);
        }
        default: {
            return state;
        }
    }
};
